import i18n from '../../i18n';
import type { PlantingLifecycleStatus } from '../../models/Planting';

const STATUS_COLORS: Record<PlantingLifecycleStatus, string> = {
  planned: 'purple',
  active: 'green',
  holding: 'cyan',
  transferred: 'geekblue',
  sold: 'gold',
  dead: 'volcano',
  archived: 'default',
};

const STATUSES = Object.keys(STATUS_COLORS) as PlantingLifecycleStatus[];

/** Status label in the current language. */
export const plantingStatusLabel = (status: PlantingLifecycleStatus): string => i18n.t(`plantings:status.${status}`);

/** `label` is a getter, so every read follows the current language. */
export const PLANTING_STATUS_META: Record<PlantingLifecycleStatus, { label: string; color: string }> = Object.fromEntries(
  STATUSES.map((status) => [status, {
    color: STATUS_COLORS[status],
    get label() { return plantingStatusLabel(status); },
  }]),
) as Record<PlantingLifecycleStatus, { label: string; color: string }>;

export const plantingStatusOptions: Array<{ value: PlantingLifecycleStatus; label: string }> = STATUSES.map((status) => ({
  value: status,
  get label() { return plantingStatusLabel(status); },
}));

export const formatPlantingStatus = (status?: PlantingLifecycleStatus | null) => {
  if (!status) return i18n.t('plantings:status.notSet');
  return STATUS_COLORS[status] ? plantingStatusLabel(status) : status;
};
